var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15360",
    "data-name": "Trazado 15360",
    d: "M170.016,7.566c-1.694-3.831-5.05-6.441-8.891-6.441s-7.2,2.613-8.892,6.441a1.918,1.918,0,0,0-.108.559,1.6,1.6,0,0,0,.108.532c1.7,3.858,5.051,6.468,8.892,6.468s7.2-2.612,8.891-6.441a2.121,2.121,0,0,0,.109-.559A1.927,1.927,0,0,0,170.016,7.566Zm-8.891,6.059c-3.109,0-5.975-2.109-7.488-5.472,1.519-3.422,4.381-5.528,7.488-5.528S167.1,4.734,168.613,8.1C167.066,11.519,164.231,13.625,161.125,13.625Zm0-9.5a4,4,0,1,0,4,4A4,4,0,0,0,161.125,4.125Zm0,6.5a2.5,2.5,0,0,1-2.5-2.5c0-.023.006-.045.007-.068a1.978,1.978,0,0,0,2.493-1.932,1.96,1.96,0,0,0-.068-.493c.025,0,.046-.007.068-.007a2.5,2.5,0,1,1,0,5Z",
    transform: "translate(-152.125 -1.125)",
    fill: "#26b4d6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDetail);
export default __webpack_public_path__ + "static/media/eye-detail.7dd8bd04.svg";
export { ForwardRef as ReactComponent };